import { render, staticRenderFns } from "./ScreenshotTools.vue?vue&type=template&id=d643b398&scoped=true&"
import script from "./ScreenshotTools.vue?vue&type=script&lang=js&"
export * from "./ScreenshotTools.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotTools.vue?vue&type=style&index=0&id=d643b398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d643b398",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
